import dependencyViewTemplate from "./DependencyViewTemplate";

var viewerStates = function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise("/dependencies");

    $stateProvider.state("dependenciesView", {
        url: "/dependencies",
        controller: "DependencyViewController",
        template: dependencyViewTemplate,
        controllerAs: "dependencyCtrl"
    });
};

viewerStates.$inject = ["$stateProvider", "$urlRouterProvider"];
export default viewerStates;
